<template>
  <v-autocomplete
    name="visitType"
    @change="handleTypeSelect"
    :no-data-text="$t('appointment.filters.noData')"
    :items="realEstateAvailableServiceTypes"
    :readonly="hasMultipleServiceTypes"
    :loading="isLoading"
    :label="label"
    :rules="rules"
    :value="value"
    :item-text="(item) => $t(`type.${item.value}`)"
    item-value="value"
    outlined
  />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import {
  visitTypeServices,
  uniqueRealtyServiceTypes,
} from '../appointmentFormDefaults'
import { rentOutTypes } from '@/components/appointment/formFieldsCreate/appointmentFormDefaults'

export default {
  name: 'AppointmentCreationTypeSelect',

  props: {
    label: {
      type: String,
    },

    rules: {
      type: Array,
    },
  },

  data() {
    return {
      value: null,
      isLoading: true,
    }
  },

  computed: {
    ...mapGetters(['realEstateAvailableServiceTypes', 'appointmentFields', 'checklistLinkedAppointmentTypes']),

    hasMultipleServiceTypes() {
      return this.services && this.services.length > 1
    },

    isRentOut() {
      return rentOutTypes.includes(this.appointmentFields.type)
    },

    realEstateId() {
      return this.appointmentFields.real_estate_id
    },
  },

  methods: {
    ...mapActions([
      'resetAppointmentFields',
      'fetchRealEstateAvailableServiceTypes',
      'fetchServiceContract',
      'fetchChecklistLinkedAppointmentTypes'
    ]),

    ...mapMutations([
      'setAppointmentFields',
      'setAppointmentFormStepsTotal',
      'setAppointmentHasMeetingLocation',
      'setAppointmentCreationConfirmToClose',
      'setAppointmentHasUniqueRealtyServiceType',
    ]),

    hasUniqueServiceType(type) {
      return uniqueRealtyServiceTypes.includes(type) || this.checklistLinkedAppointmentTypes.includes(type)
    },

    handleTypeSelect(value) {
      const { meeting_location_options } = this.appointmentFields

      Promise.resolve(this.resetAppointmentFields())
        .then(() => this.$emit('resetForm'))
        .then(() => {
          this.value = value
          this.setAppointmentFields({ type: value })
          this.value && this.setAppointmentCreationConfirmToClose(true)
        })
        .then(() => {
          this.setAppointmentHasUniqueRealtyServiceType(
            this.hasUniqueServiceType(this.appointmentFields.type)
          )
          this.checkHasMeetingLocation()
        })
        .then(() => {
          const branchId = localStorage.getItem('users_branch_id')
          const branchName = localStorage.getItem('users_branch_name')

          if (
            branchId &&
            branchId != 'undefined' &&
            branchName &&
            branchName != 'undefined'
          ) {
            this.setAppointmentFields({ real_estate_branch_id: branchId })
            this.setAppointmentFields({ real_estate_branch_name: branchName })
          }
        })
        .then(() => {
          this.setAppointmentFields({
            meeting_location_options: {
              ...meeting_location_options,
              meeting_location: 'REALTY',
            },
          })
        })
        .then(() => {
          if (this.value) {
            this.fetchServiceContract({
              type: this.value,
              realEstateId: this.realEstateId,
            })
          }
        })
    },

    checkHasMeetingLocation() {
      const { meeting_location_options } = this.appointmentFields

      Promise.resolve(this.appointmentFields.type).then((type) => {
        if (visitTypeServices.includes(type)) {
          this.setAppointmentHasMeetingLocation(true)
        } else {
          this.setAppointmentHasMeetingLocation(false)
          this.setAppointmentFields({
            meeting_location_options: {
              ...meeting_location_options,
              meeting_location: 'REALTY',
            },
          })
        }

        if (this.isRentOut) this.setAppointmentFormStepsTotal(7)
        else this.setAppointmentFormStepsTotal(6)
      })
    },

    setServiceTypeIfIsUnique() {
      if (this.realEstateAvailableServiceTypes.length <= 1) {
        this.value = this.realEstateAvailableServiceTypes[0].value

        this.setAppointmentFields({
          type: this.realEstateAvailableServiceTypes[0].value,
        })
      }
    },

    resetValue() {
      this.value = null
    },
  },

  async mounted() {
    await this.fetchChecklistLinkedAppointmentTypes()
    this.fetchRealEstateAvailableServiceTypes(this.realEstateId)
      .then(() => {
        this.setServiceTypeIfIsUnique()
      })
      .then(() => {
        this.checkHasMeetingLocation()
      })
      .then(() => {
        this.setAppointmentHasUniqueRealtyServiceType(
          this.hasUniqueServiceType(this.appointmentFields.type)
        )
      })
      .then(() => {
        if (this.value) {
          this.fetchServiceContract({
            type: this.value,
            realEstateId: this.realEstateId,
          })
        }
      })
      .finally(() => {
        this.isLoading = false
      })
  },
}
</script>
